// TODO:
// - Does the behaviour of providers, stores, strategies get simplified
//    by using generators or await?
//
const {
  EmitterInterface
} = require('../utils/events');

const events = require('../events');

const MemoryStore = require('../stores/memory-store');

const AuthToken = require('./auth-token');

const AUTH_TOKEN_KEY = 'AuthProvider.authTokens';

class AuthProvider extends EmitterInterface {
  constructor(store
  /*: ?Storage*/
  ) {
    super();
    this.store = store || new MemoryStore();
    this.tokenVersion = 0;
  } // Token management
  // Access tokens


  getTokens(checkOutOfBand
  /*: boolean*/
  )
  /*: Promise<AuthToken | null>*/
  {
    if (this.pendingRetry && !checkOutOfBand) return this.pendingRetry;
    const saved = this.store.load(AUTH_TOKEN_KEY);
    if (!saved) return Promise.resolve(null);
    return Promise.resolve(new AuthToken(saved.access, saved.refresh, this.tokenVersion));
  } // eslint-disable-next-line class-methods-use-this


  getTokenPrefix() {
    return 'Access';
  }

  setTokens(token
  /*: AuthToken*/
  ) {
    this.tokenVersion += 1;
    this.store.save(AUTH_TOKEN_KEY, {
      access: token.access,
      refresh: token.refresh
    });
    this.emit(events.AUTH_CHANGED);
  }

  setRaw(access
  /*: string*/
  , refresh
  /*: ?string*/
  ) {
    this.setTokens(new AuthToken(access, refresh, 0));
  }

  deleteTokens() {
    this.store.save(AUTH_TOKEN_KEY, null);
  }

  logout() {
    this.deleteTokens();
    this.emit(events.AUTH_LOGOUT);
  }

  refreshToken()
  /*: Promise<AuthToken | null>*/
  {
    this.deleteTokens();
    this.emit(events.AUTH_EXPIRED);
    return Promise.resolve(null);
  } // If a token was updated out of band (eg: in a new tab), set it in this auth-provider


  refreshOutOfBandToken()
  /*: Promise<AuthToken | null>*/
  {
    // TODO: If pendingRetry, resolve pending retry with the OOB token
    this.pendingRetry = null;
    return this.getTokens(true).then(oobTokens => oobTokens ? this.setTokens(oobTokens) : null).then(() => this.getTokens());
  }

}

module.exports = AuthProvider;